var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"layout"}},[_c('comp-header-pc'),_c('div',{attrs:{"id":"appMain"}},[_c('app-main')],1),_c('comp-footer-pc'),_c('comp-login-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }